import { Component } from '@angular/core';

@Component({
  selector: 'app-hero-ambulancia',
  standalone: true,
  imports: [],
  templateUrl: '../../movi-link/hero-pages/hero-movi-link.component.html',
  styleUrl: './hero-ambulancia.component.css'
})
export class HeroAmbulanciaComponent {
  title = 'Ambulancia';
  subtitle1 = 'La ayuda';
  subtitle2 = 'está en camino';
  callToAction = 'Contáctanos';
  routeImageMain = 'assets/img/ambulancia/ambulanciaHeader.svg';
}
